import { HistoryActivityContentRecord } from "Data/interfaces/History/IHistoryActivityRecord";
import { Icon } from "Components/UI";
import { GetAvatar } from "Utils/generateThumbnail";
import { getDisciplineIcon } from "Utils/ObraUtils";
import { TopicPriorityEnum, TopicVisibilityEnum } from "Data/interfaces/Activities/ITopicResponse";
import { handlePriority, handleVisibility } from "Utils/ActivitiesUtils";
import { HistoryActivityActionEnum } from "Data/interfaces/History/IHistoryActivityApi";
import {
  FileTitleContainer,
  FileStatusValue,
  FilesContentContainer,
  FilesStatusContainer,
  UsersContainer,
  FileDueDateValue,
  PontisContainer,
  ImgContainer,
} from "../styles";

const getValues = (values: string): string[] => {
  const arrayValues = values.split(',').map(value => value.trim());
  return arrayValues;
}

export const activitiesContentOptions: HistoryActivityContentRecord = {
  [HistoryActivityActionEnum.TopicCreated]: () => null,
  [HistoryActivityActionEnum.TopicStatusUpdated]: ({ item, activitiesStatusInfo }) => {
    const oldOpt = activitiesStatusInfo?.find(opt => {
      return typeof item.From.DisplayValue === 'string' &&
        opt.Name?.toLowerCase() === item.From.DisplayValue?.toLowerCase();
    });
    const newOpt = activitiesStatusInfo?.find(opt => {
      return typeof item.To.DisplayValue === 'string' &&
        opt.Name?.toLowerCase() === item.To.DisplayValue?.toLowerCase();
    });

    return (
      <FilesContentContainer>
        <FilesStatusContainer>
          <FileStatusValue
            customColor={oldOpt?.Color}
            customBGColor={`${oldOpt?.Color}1F`}
          >
            {item.From.DisplayValue}
          </FileStatusValue>
          <Icon
            icon="rightArrow"
            customSize={16}
            className="arrowIcon"
          />
          <FileStatusValue
            customColor={newOpt?.Color}
            customBGColor={`${newOpt?.Color}1F`}
          >
            {item.To.DisplayValue}
          </FileStatusValue>
        </FilesStatusContainer>
      </FilesContentContainer>
    )
  },
  [HistoryActivityActionEnum.TopicTitleUpdated]: ({ item }) => {
    return (
      <FilesContentContainer>
        <FileTitleContainer isactive="true">
          <span className="assistantText">{item?.To.DisplayValue}</span>
        </FileTitleContainer>
        <FileTitleContainer>
          <span className="assistantText">{item?.From.DisplayValue}</span>
        </FileTitleContainer>
      </FilesContentContainer>
    )
  },
  [HistoryActivityActionEnum.TopicCommunicationTypeUpdated]: ({ item }) => {
    return (
      <FilesContentContainer>
        <FileTitleContainer isactive="true">
          <span className="assistantText">{item?.To.DisplayValue || 'Vazio'}</span>
        </FileTitleContainer>
        <FileTitleContainer>
          <span className="assistantText">{item?.From.DisplayValue || 'Vazio'}</span>
        </FileTitleContainer>
      </FilesContentContainer>
    )
  },
  [HistoryActivityActionEnum.TopicDescriptionUpdated]: ({ item }) => {
    return (
      <FilesContentContainer>
        <FileTitleContainer isactive="true">
          <span className="assistantText">{item?.To.DisplayValue || 'Vazio'}</span>
        </FileTitleContainer>
        <FileTitleContainer>
          <span className="assistantText">{item?.From.DisplayValue || 'Vazio'}</span>
        </FileTitleContainer>
      </FilesContentContainer>
    )
  },
  [HistoryActivityActionEnum.TopicAssignedUsersUpdated]: ({ item }) => {
    const currentToValues = item.To.DisplayValue?.match(', ')
      ? getValues(item.To.DisplayValue)
      : item.To.DisplayValue;
    const currentFromValues = item.From.DisplayValue?.match(', ')
      ? getValues(item.From.DisplayValue)
      : item.From.DisplayValue;
    return (
      <FilesContentContainer>
        {currentToValues && (
          <UsersContainer>
            {typeof currentToValues === 'string' ? (
              <div className="usersContent">
                <span className="avatar">
                  <GetAvatar name={currentToValues} size={16} />
                </span>
                <span className="name">{currentToValues}</span>
              </div>
            ) : (
              <>
                {currentToValues?.length > 0 && currentToValues.map(value => (
                  <div className="usersContent">
                    <span className="avatar">
                      <GetAvatar name={value} size={16} />
                    </span>
                    <span className="name">{value}</span>
                  </div>
                ))}
              </>
            )}
          </UsersContainer>
        )}
        {currentFromValues && (
          <UsersContainer isold>
            {typeof currentFromValues === 'string' ? (
              <div className="usersContent">
                <span className="avatar">
                  <GetAvatar name={currentFromValues} size={16} />
                </span>
                <span className="name">{currentFromValues}</span>
              </div>
            ) : (
              <>
                {currentFromValues?.length > 0 && currentFromValues.map(value => (
                  <div className="usersContent">
                    <span className="avatar">
                      <GetAvatar name={value} size={16} />
                    </span>
                    <span className="name">{value}</span>
                  </div>
                ))}
              </>
            )}
          </UsersContainer>
        )}
      </FilesContentContainer>
    )
  },
  [HistoryActivityActionEnum.TopicDisciplinesUpdated]: ({ item }) => {
    const currentToValues = item.To.DisplayValue?.match(', ')
      ? getValues(item.To.DisplayValue)
      : item.To.DisplayValue;
    const currentFromValues = item.From.DisplayValue?.match(', ')
      ? getValues(item.From.DisplayValue)
      : item.From.DisplayValue;
    return (
      <FilesContentContainer>
        {currentToValues && (
          <UsersContainer>
            {typeof currentToValues === 'string' ? (
              <div className="disciplinesContent">
                <Icon
                  icon={getDisciplineIcon(currentToValues)}
                  className="iconDisciplina"
                />
                <span className="name">{currentToValues}</span>
              </div>
            ) : (
              <>
                {currentToValues?.length > 0 && currentToValues.map(value => (
                  <div key={value} className="disciplinesContent">
                    <Icon
                      icon={getDisciplineIcon(value)}
                      className="iconDisciplina"
                    />
                    <span className="name">{value}</span>
                  </div>
                ))}
              </>
            )}
          </UsersContainer>
        )}
        {currentFromValues && (
          <UsersContainer isold>
            {typeof currentFromValues === 'string' ? (
              <div className="disciplinesContent">
                <Icon
                  icon={getDisciplineIcon(currentFromValues)}
                  className="iconDisciplina"
                />
                <span className="name">{currentFromValues}</span>
              </div>
            ) : (
              <>
                {currentFromValues?.length > 0 && currentFromValues.map(value => (
                  <div key={value} className="disciplinesContent">
                    <Icon
                      icon={getDisciplineIcon(value)}
                      className="iconDisciplina"
                    />
                    <span className="name">{value}</span>
                  </div>
                ))}
              </>
            )}
          </UsersContainer>
        )}
      </FilesContentContainer>
    )
  },
  [HistoryActivityActionEnum.TopicDueDateUpdated]: ({ item }) => {
    return (
      <FilesContentContainer>
        <FilesStatusContainer>
          <FileDueDateValue isold>
            {item.From.DisplayValue && (
              <Icon
                icon="calendar"
                customSize={18}
                className="iconDate"
              />
            )}
            <span className="value">
              {item.From.DisplayValue || 'Vazio'}
            </span>
          </FileDueDateValue>
          <Icon
            icon="rightArrow"
            customSize={16}
            className="arrowIcon"
          />
          <FileDueDateValue>
            {item.To.DisplayValue && (
              <Icon
                icon="calendar"
                customSize={18}
                className="iconDate"
              />
            )}
            <span className="value">
              {item.To.DisplayValue || 'Vazio'}
            </span>
          </FileDueDateValue>
        </FilesStatusContainer>
      </FilesContentContainer>
    )
  },
  [HistoryActivityActionEnum.TopicVisibilityUpdated]: ({ item, theme }) => {
    const visibilityEnum: Record<string, TopicVisibilityEnum> = {
      'Público': TopicVisibilityEnum.Public,
      'Privado': TopicVisibilityEnum.Private,
      'Rascunho': TopicVisibilityEnum.Draft,
    };

    return (
      <FilesContentContainer>
        <FilesStatusContainer>
          <FileDueDateValue isold>
            {typeof item.From.DisplayValue === 'string' && theme && (
              <Icon
                icon={handleVisibility(visibilityEnum[item.From.DisplayValue], theme).icon}
                customSize={handleVisibility(visibilityEnum[item.From.DisplayValue], theme).size}
                className="iconVisibility"
              />
            )}
            <span className="value">
              {item.From.DisplayValue || 'Vazio'}
            </span>
          </FileDueDateValue>
          <Icon
            icon="rightArrow"
            customSize={16}
            className="arrowIcon"
          />
          <FileDueDateValue>
            {typeof item.To.DisplayValue === 'string' && theme && (
              <Icon
                icon={handleVisibility(visibilityEnum[item.To.DisplayValue], theme).icon}
                customSize={handleVisibility(visibilityEnum[item.To.DisplayValue], theme).size}
                customColor={handleVisibility(visibilityEnum[item.To.DisplayValue], theme).color}
                className="iconVisibility"
              />
            )}
            <span className="value">
              {item.To.DisplayValue || 'Vazio'}
            </span>
          </FileDueDateValue>
        </FilesStatusContainer>
      </FilesContentContainer>
    )
  },
  [HistoryActivityActionEnum.TopicPriorityUpdated]: ({ item, theme }) => {
    const visibilityEnum: Record<string, TopicPriorityEnum> = {
      'Alta': TopicPriorityEnum.High,
      'Média': TopicPriorityEnum.Medium,
      'Baixa': TopicPriorityEnum.Low,
    };

    return (
      <FilesContentContainer>
        <FilesStatusContainer>
          <FileDueDateValue isold>
            {typeof item.From.DisplayValue === 'string' && theme && (
              <Icon
                icon={handlePriority(visibilityEnum[item.From.DisplayValue], theme).icon}
                customSize={handlePriority(visibilityEnum[item.From.DisplayValue], theme).size}
                className="iconPriority"
              />
            )}
            <span className="value">
              {item.From.DisplayValue || 'Vazio'}
            </span>
          </FileDueDateValue>
          <Icon
            icon="rightArrow"
            customSize={16}
            className="arrowIcon"
          />
          <FileDueDateValue>
            {typeof item.To.DisplayValue === 'string' && theme && (
              <Icon
                icon={handlePriority(visibilityEnum[item.To.DisplayValue], theme).icon}
                customSize={handlePriority(visibilityEnum[item.To.DisplayValue], theme).size}
                customColor={handlePriority(visibilityEnum[item.To.DisplayValue], theme).color}
                className="iconPriority"
              />
            )}
            <span
              className="value"
              style={{
                color: typeof item.To.DisplayValue === 'string' && theme
                  ? handlePriority(visibilityEnum[item.To.DisplayValue], theme).color
                  : undefined
              }}
            >
              {item.To.DisplayValue || 'Vazio'}
            </span>
          </FileDueDateValue>
        </FilesStatusContainer>
      </FilesContentContainer>
    )
  },
  [HistoryActivityActionEnum.TopicLocationUpdated]: ({ item }) => {
    const currentToValues = item.To.DisplayValue?.match(', ')
      ? getValues(item.To.DisplayValue)
      : item.To.DisplayValue;
    const currentFromValues = item.From.DisplayValue?.match(', ')
      ? getValues(item.From.DisplayValue)
      : item.From.DisplayValue;
    return (
      <FilesContentContainer>
        {item.To.DisplayValue && (
          <PontisContainer>
            {typeof currentToValues === 'string' ? (
              <span className="name">{currentToValues}</span>
            ) : (
              <>
                {currentToValues && currentToValues?.length > 0 && currentToValues?.map(value => (
                  <span key={value} className="name">{value}</span>
                ))}
              </>
            )}
          </PontisContainer>
        )}
        {item.From.DisplayValue && (
          <PontisContainer isold>
            {typeof currentFromValues === 'string' ? (
              <span className="name">{currentFromValues}</span>
            ) : (
              <>
                {currentFromValues && currentFromValues?.length > 0 && currentFromValues?.map(value => (
                  <span key={value} className="name">{value}</span>
                ))}
              </>
            )}
          </PontisContainer>
        )}
      </FilesContentContainer>
    )
  },
  [HistoryActivityActionEnum.TopicAttachmentAdded]: ({ item }) => {
    return (
      <FilesContentContainer>
        {item.To.DisplayValue && typeof item.To.DisplayValue === 'string' && (
          <ImgContainer>
            <img alt="" src={item.To.DisplayValue} className="img" />
          </ImgContainer>
        )}
      </FilesContentContainer>
    )
  },
  [HistoryActivityActionEnum.TopicAttachmentDeleted]: () => null,
  [HistoryActivityActionEnum.TopicStageUpdated]: ({ item }) => {
    return (
      <FilesContentContainer>
        <FileTitleContainer isactive="true">
          <span className="assistantText">{item?.To.DisplayValue || 'Vazio'}</span>
        </FileTitleContainer>
        <FileTitleContainer>
          <span className="assistantText">{item?.From.DisplayValue || 'Vazio'}</span>
        </FileTitleContainer>
      </FilesContentContainer>
    )
  },
};
